import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, Renderer2 } from '@angular/core';

@Component({
    selector: 'app-dropdown-menu',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss'],
    imports: [CommonModule]
})
export class DropdownComponent implements OnInit {
    menuOpen: boolean = false;
    menuStyles: any = {};

    private DROPDOWN_WIDTH: number = 0;
    private menuElement: HTMLElement | null = null;

    @Output() menuOpened = new EventEmitter<void>();
    @Output() menuClosed = new EventEmitter<void>();

    constructor(private el: ElementRef, private renderer: Renderer2) { }

    ngOnInit() {
        this.menuElement = this.el.nativeElement.querySelector('[dropdown-content]')
    }

    toggleMenu(event?: MouseEvent) {
        if (event) {
            event.stopPropagation()
        }

        this.menuOpen = !this.menuOpen

        if (this.menuOpen) {
            this.menuOpened.emit()
            setTimeout(() => {
                this.calculatePosition()
            }, 0)
        } else {
            this.menuClosed.emit()
        }
    }

    closeMenu(stopPropagate: boolean = true, event?: MouseEvent) {
        const wasOpen = this.menuOpen
        this.menuOpen = false

        if (wasOpen) {
            this.menuClosed.emit()
        }

        if (stopPropagate && event) {
            event.stopPropagation()
        }
    }

    // 🔹 Nouvelle méthode pour empêcher la propagation des clics dans le dropdown
    onDropdownContentClick(event: MouseEvent) {
        // Empêcher la propagation pour que le clic ne remonte pas au parent (overlay ou th)
        event.stopPropagation()

        // console.log('🔽 Clic dans le dropdown - propagation arrêtée')
    }

    @HostListener('document:keydown.escape', ['$event'])
    onEscapeKey(event: any) {
        if (this.menuOpen) {
            event.preventDefault()
            event.stopPropagation()

            this.menuOpen = false
            this.menuClosed.emit()
        }
    }

    @HostListener('click', ['$event'])
    onHostClick(event: MouseEvent) {
        const clickedElement = event.target as HTMLElement
        const dropdownButton = this.el.nativeElement.querySelector('[dropdown-button]')

        if (dropdownButton && dropdownButton.contains(clickedElement)) {
            this.toggleMenu(event)
        }
    }

    @HostListener('window:resize')
    onWindowResize() {
        if (this.menuOpen) {
            this.calculatePosition()
        }
    }

    private calculatePosition() {
        const hostElement = this.el.nativeElement as HTMLElement
        const buttonElement = hostElement.querySelector('[dropdown-button]') as HTMLElement | null
        this.menuElement = hostElement.querySelector('.profile-menu-dropdown') as HTMLElement | null

        if (!buttonElement || !this.menuElement) {
            return
        }

        const tableFilterElement = buttonElement.closest('.table-filter-scroll') as HTMLElement | null
        const hostRect = hostElement.getBoundingClientRect()
        const buttonRect = buttonElement.getBoundingClientRect()
        const boundaryRect = tableFilterElement?.getBoundingClientRect()

        const boundaryLeft = boundaryRect?.left ?? 0
        const boundaryRight = boundaryRect?.right ?? window.innerWidth
        const margin = 10
        const dropdownWidth = this.menuElement.offsetWidth

        const leftOffset = buttonRect.left - hostRect.left
        const rightOffset = hostRect.right - buttonRect.right

        const fitsWithLeftAlignment = buttonRect.left + dropdownWidth <= boundaryRight - margin
        if (fitsWithLeftAlignment) {
            this.menuStyles = {
                'left': `${leftOffset}px`,
                'right': 'unset'
            }
            return
        }

        const fitsWithRightAlignment = buttonRect.right - dropdownWidth >= boundaryLeft + margin
        if (fitsWithRightAlignment) {
            this.menuStyles = {
                'left': 'unset',
                'right': `${rightOffset}px`
            }
            return
        }

        const clampedLeft = Math.max(
            boundaryLeft + margin,
            Math.min(buttonRect.left, boundaryRight - margin - dropdownWidth)
        )

        this.menuStyles = {
            'left': `${clampedLeft - hostRect.left}px`,
            'right': 'unset'
        }
    }
}
